import type { CustomerBalanceResponse, TransactionHistoryResponse, LoyaltyPolicyResponse } from '../../../model/loyalty/loyalty';
import type { Currency } from '../../../constants';

// GET /loyalty/balance/{customerId}
export type GetCustomerBalanceRequest = {
  customerId: string;
};

export type GetCustomerBalanceResponse = CustomerBalanceResponse;

// GET /loyalty/transactions/{customerId}
export type GetTransactionHistoryRequest = {
  customerId: string;
  limit?: number;
  lastEvaluatedKey?: string;
};

export type GetTransactionHistoryResponse = TransactionHistoryResponse;

// GET /loyalty/policy
export type GetLoyaltyPolicyRequest = {
  currency: Currency;
};

export type GetLoyaltyPolicyResponse = LoyaltyPolicyResponse;

